<template>
<div class="shop-edit contents">
  <div v-if="form.hasErrors()" class="ui warning message">入力エラー</div>
  <div class="ui pointing secondary menu">
    <a class="item" data-tab="basic">基本情報</a>
    <a class="item" data-tab="photo">写真</a>
    <a class="item" data-tab="menu">メニュー</a>
    <a class="item" data-tab="room">会場</a>
    <a class="item" data-tab="facility">設備</a>
    <a class="item" data-tab="additional_condition">詳細情報</a>
    <a v-if="isStaff" class="item" data-tab="account">ログイン情報</a>
  </div>

  <basic-tab :form="form" @save="save()"></basic-tab>
  <photo-tab ref="photoTab"></photo-tab>
  <menu-tab ref="menuTab"></menu-tab>
  <room-tab ref="roomTab"></room-tab>
  <facility-tab ref="facilityTab"></facility-tab>
  <additional-condition-tab ref="additionalConditionTab"></additional-condition-tab>
  <account-tab v-if="isStaff" ref="accountTab"></account-tab>

</div>
</template>

<script>
import BasicTab from './edit/basicTab.vue';
import PhotoTab from './edit/photoTab.vue';
import MenuTab from './edit/menuTab.vue';
import RoomTab from './edit/roomTab.vue';
import FacilityTab from './edit/facilityTab.vue';
import AdditionalConditionTab from './edit/additionalConditionTab.vue';
import AccountTab from './edit/accountTab.vue';

export default {
    components: {
        BasicTab: BasicTab,
        PhotoTab: PhotoTab,
        MenuTab: MenuTab,
        RoomTab: RoomTab,
        FacilityTab: FacilityTab,
        AdditionalConditionTab: AdditionalConditionTab,
        AccountTab: AccountTab,
    },
    props: {
        detailApiUrl: {
            required: true,
            type: String
        }
    },
    data: function() {
        return {
            detailApiPath: null,
            form: this.createForm(),
        };
    },
    created: function() {
        this.form.get(this.detailApiUrl, function(response) {
            this.merge(this.form.model, response.data);
            this.$refs.photoTab.initialize(this.form.model);
            this.$refs.roomTab.initialize(this.form.model);
            this.$refs.menuTab.initialize(this.form.model);
            this.$refs.facilityTab.initialize(this.form.model);
            this.$refs.additionalConditionTab.initialize(this.form.model);
            this.$refs.accountTab && this.$refs.accountTab.initialize(this.form.model);
        }.bind(this));
    },
    mounted: function() {
        $('.menu .item').tab({
            history: true,
            historyType: 'hash'
        });
        $('.ui.checkbox').checkbox();
    },
    methods: {
        save: function() {
            this.form.put(this.detailApiUrl, function() {
                alert('保存しました');
            }.bind(this));
        }
    }
};
</script>
